import styled from 'styled-components';
import { ContainerProps } from '../../types';

const Container = styled.div<{ className?: string }>`
  max-width: 80rem;
  margin: 0 auto;
  padding: 3.2rem 4.8rem;
  background-color: var(--color-light);
  border-radius: 1rem;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-medium);

  /* Elegant decorative elements */
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 1rem;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    border: 1px solid rgba(212, 175, 55, 0.2); /* Light gold border */
    border-radius: 0.5rem;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 2.4rem 3.2rem;
  }

  @media (max-width: 576px) {
    padding: 1.6rem 2.4rem;
  }
`;

export default Container;
